<template>
    <b-alert :show="enabled && !busy && openCount > 0" variant="warning" class="d-flex align-items-center mb-2">
        <i class="fas fa-exclamation-triangle mr-2"></i>
        <div class="flex-grow-1">
            <strong>Open order{{ openCount === 1 ? "" : "s" }} in progress:</strong>
            this patient already has {{ openCount }} open order{{ openCount === 1 ? "" : "s" }}.
            Review before creating another to avoid duplicates.
        </div>
        <b-button size="sm" variant="outline-dark" @click="viewOrders">View orders</b-button>
    </b-alert>
</template>

<script lang="ts">
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import OrderService from "@/services/OrderService";
import { Order } from "@/models/Order";
import { countOpenOrders } from "@/util/openOrders";

@Component
export default class OpenOrdersBanner extends Vue {
    @Prop({ type: Number, required: true }) patientId!: number;
    @Prop({ type: Array, default: () => [] }) orders!: Order[];
    @Prop({ type: Boolean, default: false }) busy!: boolean;

    private enabled = false;

    get openCount(): number {
        return countOpenOrders(this.orders);
    }

    async mounted() {
        await this.load();
    }

    @Watch("patientId")
    async onPatientChanged() {
        await this.load();
    }

    async load() {
        this.enabled = !!this.patientId && await OrderService.isDuplicateOpenOrderCheckEnabled();
    }

    viewOrders() {
        this.$emit("view");
        document.querySelector('[data-card-id="orders"]')?.scrollIntoView({ behavior: "smooth" });
    }
}
</script>
